module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-pop@2x-7565e54f745f94dcddffebff667ef6e9.png";